import { render } from "./resonanceResult.vue?vue&type=template&id=270ec33f&scoped=true"
import script from "./resonanceResult.vue?vue&type=script&lang=js"
export * from "./resonanceResult.vue?vue&type=script&lang=js"

import "./resonanceResult.vue?vue&type=style&index=0&id=270ec33f&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270ec33f"]])

export default __exports__